<template>

  <nav
    class="navbar fixed-top navbar-expand-lg navbar-dark bg-dark adapted-meet-max-width">
    <router-link
      class="navbar-brand" to="/">
      <img
        src="../assets/img/logo-quickin-fp.png"
        height="22"
        style="display: block;">
      </router-link>

    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      class="collapse navbar-collapse"
      id="navbarSupportedContent">
      <MainMenuChangeModule
        v-if="account.sampleRhevolut" />

      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/">{{ $t('Jobs') }}</router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/requisitions">{{ $t('Requisitions') }}</router-link>
        </li>
        <li class="nav-item">
          <router-link
          class="nav-link"
          to="/candidates">{{ $t('Candidates') }}</router-link>
        </li>
      </ul>

      <ul class="navbar-nav">
        <li
          v-if="billingNotification"
          class="nav-item">
          <router-link
            :is="permissions.includes('manage_billing') ? 'router-link' : 'span'"
            class="nav-link text-warning"
            to="/billing">
            <i class="fa fa-warning" />
            {{ billingNotification }}
            </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            to="/calendar">
            <i class="far fa-calendar-alt" />
            <span class="hide-bigger-sm">{{ $t('Calendar') }}</span>
            </router-link>
        </li>
        <li
          v-if="permissions.includes('manage_candidates')"
          class="nav-item">
          <router-link
            class="nav-link"
            to="/email">
            <span
              v-if="profileCounts.emails"
              class="badge badge-pill badge-danger">
              {{ profileCounts.emails }}
              </span>
              <i class="fas fa-envelope" />
              <span class="hide-bigger-sm">{{ $t('E-mails') }}</span>
            </router-link>
        </li>
        <li class="nav-item">
          <a
            href="javascript:void(0)"
            class="nav-link"
            @click="showNotifications">
            <span
              v-if="profileCounts.notifications"
              class="badge badge-pill badge-danger">
              {{ profileCounts.notifications }}
              </span>
              <i class="fas fa-bell" />
              <span class="hide-bigger-sm">{{ $t('Notifications') }}</span>
            </a>
        </li>
        <li
          v-if="permissions.includes('manage_candidates')"
          class="nav-item">
          <a
            href="javascript:void(0)"
            class="nav-link"
            @click="showTasks">
            <i class="fas fa-check-square" />
            <span class="hide-bigger-sm">{{ $t('Tasks') }}</span>
            </a>
        </li>
        <li
          v-if="permissions.includes('view_simple_report')"
          class="nav-item">
          <router-link
            class="nav-link"
            to="/dashboards"> <!--to="/reports/disqualify-reasons?menu_open=true"-->
            <i class="fas fa-chart-pie" />
            <span class="hide-bigger-sm">{{ $t('Reports') }}</span>
          </router-link>
        </li>
      </ul>

      <form class="form-inline my-2 my-lg-0">
        <div class="serach mr-sm-2 ml-sm-2" style="width: 100%">
          <CandidateQuickSearch />
        </div>
      </form>
      
      <ul class="navbar-nav">
        <li class="nav-item">
          <a
            href="javascript:void(0)"
            class="nav-link cursor-pointer"
            style="cursor: pointer;"
            id="bt-help">
            <span
              v-if="intercomUnreadCount"
              class="badge badge-pill badge-danger">{{ intercomUnreadCount }}</span>
              <i class="fa-regular fa-circle-question"></i>
              <span class="hide-bigger-sm">{{ $t('Help') }}</span>
          </a>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            {{ me.name }}
            <i class="fas fa-cog" />
            </a>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="navbarDropdown">
            <router-link
              class="dropdown-item"
              to="/config">
              {{ $t('Settings') }}
              </router-link>
            <router-link
              v-if="permissions.includes('manage_billing') && account.billing_enable"
              class="dropdown-item"
              to="/billing">
              {{ $t('Billing') }}
              </router-link>
            <router-link
              class="dropdown-item"
              to="/my-account">
              {{ $t('My accounts') }}
              </router-link>
            <a
              class="dropdown-item"
              href="javascript:void(0)"
              @click="exit()">
              {{ $t('Logout') }}
              </a>
            <hr>
            <a
              :href="account.career_url"
              target="_blank"
              class="dropdown-item">
              <i class="fas fa-external-link-alt" />
              {{ $t('Careers site') }}
              </a>
            </div>
        </li>
      </ul>
      
    </div>
  </nav>

</template>

<script>
import CandidateQuickSearch from './CandidateQuickSearch/CandidateQuickSearch'
import MainMenuChangeModule from './MainMenuChangeModule'

export default {
  name: 'Main',
  components: {
    CandidateQuickSearch,
    MainMenuChangeModule
  },
  data () {
    return {
      loaddind: false,
      interval: null,
      intercomUnreadCount: 0
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    me () {
      return this.$store.getters.getMe
    },
    account () {
      return this.$store.getters.getAccount
    },
    profileCounts () {
      return this.$store.getters.getProfileCounts || {}
    },
    billingNotification () {
      if (this.account.billing_enable) {
        if (this.account.is_prolong && this.account.prolong_reason === 'trial') {
          if (this.account.prolong_is_after) {
            return `Trial termina ${this.$options.filters.moment(this.account.prolong_date, 'fromNow', this.$i18n.locale)}.`
          } else {
            return `Trial expirado.`
          }
        } else if (this.account.is_overdue_invoice) {
          return `Fatura vencida.`
        }
      }
      return null
    }
  },
  created () {
    this.$store.dispatch('setProfileCounts')
    this.interval = setInterval(() => {
      this.$store.dispatch('setProfileCounts')
    }, (60 * 1000))
  },
  mounted () {
    this.showIntercom()
    $('.navbar-nav a').not('.dropdown-toggle').on('click', function () {
      $('.navbar-collapse').collapse('hide')
    })
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    exit () {
      this.$store.dispatch('authLogout')
      this.$router.push('/auth')
    },
    showNotifications () {
      this.$changeUrlParam({
        notifications: true
      })
    },
    showTasks () {
      this.$changeUrlParam({
        tasks: true
      })
    },
    showIntercom () {
      // intercom
      this.$intercom.boot({
        user_id: this.me._id,
        name: this.me.name,
        email: this.me.email,
        permissions: this.permissions,
        custom_launcher_selector: '#bt-help',
        hide_default_launcher: true
      })
      window.Intercom('onUnreadCountChange', (unreadCount) => {
        this.intercomUnreadCount = unreadCount
      })
      this.$intercom.hide()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-item > .nav-link > i {
  font-size: 1.25em;
}
.navbar .cursor-pointer {
  cursor: pointer;
}
.nav-item > .nav-link > .badge {
  float: right; margin: -3px 0 0 -3px
}

@media (max-width : 576px) {
  .navbar-collapse {
    overflow: auto;
    max-height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue